import React, { useEffect, useMemo, useState } from 'react';

import { useKeycloak } from '@react-keycloak/web';

import RedirectToKeycloak from './RedireactToKeycloak';
import { UserDataProvider } from '../../App/Component/UserDataProvider';
import {
  getKeyCloakRealmFromLS,
  getSessionStorage,
  removeKeyCloakRealmOnLS,
} from '../../Authentication/Actions/authentication';
import DocumentLibraryProvider from '../../DocumentLibrary/Component/DocumentLibraryProvider';
import BarLoader from '../../UniversalComponents/Loader/barLoader';

interface IProps {
  handleKeycloakRealmNameChange: (realmName: string) => void;
  children: React.ReactNode;
}

const PrivateRoute: React.FC<IProps> = ({
  handleKeycloakRealmNameChange,
  children,
}) => {
  const { keycloak, initialized } = useKeycloak();
  const keycloakRealmName = getKeyCloakRealmFromLS();
  const isLoggedIn = keycloak.authenticated;
  const [loadingTime, setLoadingTime] = useState(0);

  const handleKeycloakRedirection = () => {
    if (keycloak && !isLoggedIn) {
      keycloak.login();
    }
  };

  useEffect(() => {
    if (isLoggedIn) {
      //do nothing
    } else if (!initialized && loadingTime === 1) {
      removeKeyCloakRealmOnLS();
      window.location.reload();
    }
  }, [isLoggedIn, loadingTime, initialized]);

  const accessToken = useMemo(
    () => getSessionStorage('accessToken'),
    [getSessionStorage('accessToken')]
  );

  if (!initialized) {
    setTimeout(() => {
      setLoadingTime(1);
    }, 10000);

    return <BarLoader />;
  } else if (isLoggedIn && accessToken !== undefined) {
    return (
      <UserDataProvider>
        <DocumentLibraryProvider>{children}</DocumentLibraryProvider>
      </UserDataProvider>
    );
  } else {
    return (
      <RedirectToKeycloak
        keycloakRealmName={keycloakRealmName}
        handleKeycloakRedirection={handleKeycloakRedirection}
        handleKeycloakRealmNameChange={handleKeycloakRealmNameChange}
      />
    );
  }
};

export default PrivateRoute;
